import React from 'react';
import { Scrollbars, ScrollbarProps } from 'react-custom-scrollbars-2';

const ScrollbarWrapper: React.FC<ScrollbarProps> = (props) => <Scrollbars {...props} />;

export default ScrollbarWrapper;
